export const SENTRY_VERSION = 'ee904474916865362c21f095436b9492ce18a754';



// WEBPACK FOOTER //
// ./src/sentry-version.ts